// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"99e0a1b2","58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","370":"c8f1686f","458":"62aa5cc7","505":"db946cdb","577":"66801e42","652":"34876035","682":"d5252985","783":"c66ca607","812":"e16e9c63","867":"83739125","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};